import React, { useState } from 'react';
import { Button, Brushaway, BrushawayBody, BrushawayFooter, BrushawayHeader, InlineNotification } from '@ui';
import { Text } from '@ui/atoms/Text';
import { Tag } from '@ui/atoms/Tag';
import { TextInput } from '@ui/molecules/inputs/form/TextInput';
import { Checkbox } from '@ui/molecules/inputs/Checkbox';
import './AllowlistPanelStyles.scss';
const USERS = [
    { id: 1, name: 'Ada Lovelace', username: 'ada@example.com', role: 'admin' },
    { id: 2, name: 'Grace Hopper', username: 'grace@example.com', role: 'user' },
    { id: 26, name: 'Office Admin', username: 'admin+test@test.com', role: 'admin' }
];
const meta = {
    title: 'Features/CustomerFileDrop/AllowlistPanel',
    tags: ['autodocs'],
    parameters: { layout: 'fullscreen' }
};
export default meta;
/** User Access allowlist in a Quimby Brushaway (matches live page chrome). */
export const Default = {
    render: () => {
        const [selectedIds, setSelectedIds] = useState([26]);
        const [search, setSearch] = useState('');
        const filtered = USERS.filter((u) => !search ||
            u.name.toLowerCase().includes(search.toLowerCase()) ||
            u.username.toLowerCase().includes(search.toLowerCase()));
        const badgeLabel = `${selectedIds.length} users`;
        return (React.createElement("div", { style: { height: '100vh', padding: 24 } },
            React.createElement(Brushaway, { minWidth: 420, closeOnClickOutside: true, controlledOpen: true, anchor: ({ onClick }) => (React.createElement(Button, { variant: "secondary", onClick: onClick, "data-testid": "manage-allowlist-button" },
                    React.createElement("i", { className: "fa-light fa-users", "aria-hidden": "true" }),
                    "User Access",
                    React.createElement(Tag, { label: badgeLabel }))) },
                React.createElement(BrushawayHeader, { title: "User Access", secondaryActions: React.createElement(Tag, { label: badgeLabel }) }),
                React.createElement(BrushawayBody, null,
                    React.createElement("div", { className: "allowlist-panel", "data-testid": "allowlist-panel" },
                        React.createElement(TextInput, { id: "story-allowlist-search", label: "Search by name or email\u2026", value: search, onChange: (e) => setSearch(e.target.value) }),
                        React.createElement("div", { className: "allowlist-panel__user-list" }, filtered.map((user) => (React.createElement("div", { key: user.id, className: "allowlist-panel__user-row" },
                            React.createElement(Checkbox, { id: `story-user-${user.id}`, checked: selectedIds.includes(user.id), onChange: (checked) => setSelectedIds((prev) => checked ? [...new Set([...prev, user.id])] : prev.filter((id) => id !== user.id)), label: React.createElement("span", { className: "allowlist-panel__user-info" },
                                    React.createElement(Text, { variant: "body" }, user.name),
                                    React.createElement(Text, { variant: "x-small" }, user.username)) }),
                            React.createElement(Tag, { label: user.role }))))),
                        React.createElement(InlineNotification, { variant: "success", title: "User access updated.", children: React.createElement("span", null, "User access updated.") }))),
                React.createElement(BrushawayFooter, null,
                    React.createElement(Button, null, "Save")))));
    }
};
